// extracted by mini-css-extract-plugin
module.exports = {"customers":"styles_customers__19BwU"};